import React from 'react'
import { Link } from 'react-router-dom'
import { WebsitePage } from '../../layouts/WebsitePage'
import './styles.css'

type Props = {
}

export const About: React.FC<Props> = () => {
  return (
    <WebsitePage>
      <div id="about">
        <h2>We are Phrayz</h2>
        <h1>We selfishly wanted to make the software for ourselves.</h1>
        <h3>
            The tool saves us tons of time making content. So we thought it could help other marketers and business professionals as well.
        </h3>

        <h2>The name Phrayz</h2>
        <h1>Our Story</h1>
        <p>
            The name Phrayz comes from the term paraphrase. Marketers sometimes make content by paraphrasing industry news, and or trends.  
        </p>
        <p>

            A typical selling point of marketers is to take time off of business owner's hands. But, where does that time go? It doesn't just disappear. Marketers know first-hand how long it takes to create content. The beginning steps of research, strategy, and pre production. The middle steps of production. The next steps of editing, and scheduling. Then the final steps of reporting analytics, and making further decisions. It's very tedious, but also the day-to-day for many marketing professionals. Phrayz was created to help save marketers time. 

        </p>
        <p>
            Brands trust Marketers to not only use their assets in posts, but also industry specific information and terminology as well. Marketers have to now become experts in the industries that they help. Phrayz lets Marketers subscribe to industry specific newsletters without them flooding their inbox. It then summarizes them, and offers content outlines for you to then use and elaborate on. We find that email newsletters are a great way to find relevant and timely industry news. 

        </p>
        <p>
            Currently we are testing Phrayz and we'd love for you to check it out. Tell us what you think. Let us know all of your gripes, and favorite parts.
        </p>
        <div className="action">
          <Link to="/login">
            <button className="primary" type="button">
                Try for Free
            </button>
          </Link>
        </div>
        <a href="mailto:hello@inbox.phrayz.com">
          <img src="/assets/jack.png" alt="Jack Fleming" width={350} />
        </a>
      </div>
    </WebsitePage>
  )
}

